import Prism from 'prismjs'
import { Block } from 'slate'

import Options from './options'
import TOKEN_MARK from './TOKEN_MARK'

Prism.plugins.NormalizeWhitespace.setDefaults({
	'remove-trailing': true,
	'remove-indent': true,
	'left-trim': true,
	'right-trim': true,
	'break-lines': 80,
	indent: 4,
	'remove-initial-line-feed': false,
	'tabs-to-spaces': 4,
	'spaces-to-tabs': 4,
})

export function SlatePrism(optsParam) {
	const opts = new Options(optsParam)

	return {
		decorateNode: (node, editor, next) => {
			if (!opts.onlyIn(node)) {
				return next()
			}

			return decorateNode(opts, Block.create(node))
		},

		renderDecoration: (props, editor, next) =>
			opts.renderDecoration(
				{
					children: props.children,
					decoration: props.decoration,
				},
				editor,
				next
			),
	}
}

function decorateNode(opts, block) {
	const grammarName = opts.getSyntax(block)
	const grammar = Prism.languages[grammarName]

	if (!grammar) {
		return []
	}

	const texts = block.getTexts()
	const blockText = texts.map(text => text && text.getText()).join('\n')
	const tokens = Prism.tokenize(blockText, grammar)

	const decorations = []
	let textStart = 0
	let textEnd = 0

	texts.forEach(text => {
		textEnd = textStart + text.getText().length

		let offset = 0

		function processToken(token, accu) {
			if (typeof token === 'string') {
				if (accu) {
					const decoration = createDecoration({
						text,
						textStart,
						textEnd,
						start: offset,
						end: offset + token.length,
						className: `prism-token token ${accu}`,
						block,
					})

					if (decoration) {
						decorations.push(decoration)
					}
				}
				offset += token.length
			} else {
				accu = `${accu} ${token.type} ${token.alias || ''}`

				if (typeof token.content === 'string') {
					const decoration = createDecoration({
						text,
						textStart,
						textEnd,
						start: offset,
						end: offset + token.content.length,
						className: `prism-token token ${accu}`,
						block,
					})

					if (decoration) {
						decorations.push(decoration)
					}

					offset += token.content.length
				} else {
					// When using token.content instead of token.matchedStr, token can be deep
					for (let i = 0; i < token.content.length; i += 1) {
						processToken(token.content[i], accu)
					}
				}
			}
		}

		tokens.forEach(processToken)
		textStart = textEnd + 1 // account for added `\n`
	})

	return decorations
}

function createDecoration({
	text,
	textStart,
	textEnd,
	start,
	end,
	className,
	block,
}) {
	if (start >= textEnd || end <= textStart) {
		// Ignore, the token is not in the text
		return null
	}

	// Shrink to this text boundaries
	start = Math.max(start, textStart)
	end = Math.min(end, textEnd)

	// Now shift offsets to be relative to this text
	start -= textStart
	end -= textStart

	const myDec = block.createDecoration({
		object: 'decoration',
		anchor: {
			key: text.key,
			offset: start,
			object: 'point',
		},
		focus: {
			key: text.key,
			offset: end,
			object: 'point',
		},
		type: TOKEN_MARK,
		data: { className },
	})

	return myDec
}
